import React from 'react';
import DropdownMenu from "../Dropdown/DropdownMenu";
var defaultProps = {
  maxHeight: '12rem'
};

var ComboboxItems = function ComboboxItems(_ref) {
  var children = _ref.children,
      _ref$maxHeight = _ref.maxHeight,
      maxHeight = _ref$maxHeight === void 0 ? defaultProps.maxHeight : _ref$maxHeight;
  return /*#__PURE__*/React.createElement(DropdownMenu, {
    className: "w-100",
    style: {
      maxHeight: maxHeight,
      overflowY: 'auto'
    },
    title: "Menu Items",
    updateOnSelect: true
  }, /*#__PURE__*/React.createElement("div", null, children));
};

ComboboxItems.displayName = "ComboboxItems";
export default ComboboxItems;